import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { BrandThemeSvgProps } from '../types';

const AnchorageLogo = (props: BrandThemeSvgProps): JSX.Element => {
  return <SpriteIcon spriteId="anchorage-logo" {...props} />;
};

export { AnchorageLogo };
